module.exports = __webpack_public_path__ + "static/img/zz-icon.1e454b37.png";